import { config } from './config';
export class Base {
    constructor(config) {
        this.isAndroid = false;
        this.isIos = false;
        this.isWX = false;
        this.isQQ = false;
        this.isQZ = false;
        this.isTBS = false;
        this.isQb = false;
        try {
            this.setConfig(config);
            this.init();
        }
        catch (error) {
            console.log(error);
        }
    }
    setConfig(config) {
        this.config = {
            androidWxBackUrl: ',packagename=com.tencent.mm',
            androidQqBackUrl: ',packagename=com.tencent.mobileqq',
            iosWxBackUrl: ',backparm=wechat://,iconid=6',
            iosQqBackUrl: ',backparm=mqq://whatever,iconid=3',
            wxApiUrl: '//res.wx.qq.com/open/js/jweixin-1.0.0.js',
            qqApiUrl: '//pub.idqqimg.com/qqmobile/qqapi.js?_bid=154',
            wxPlay: 2,
            qbPackagename: 'com.tencent.mtt',
            qbSchema: 'mttbrowser://',
            qbWxAppId: 'wx64f9cf5b17af074d',
            qbQqAppId: '100446242',
            kbPackageName: 'com.tencent.reading',
            kbSchemaName: 'qnreading',
            kbWxAppId: 'wxe90c9765ad00e2cd',
            kbQqAppId: '101480433'
        };
        if (!config || typeof config !== 'object') {
            return;
        }
        if (!config.appId) {
            throw new Error('appId required');
        }
        this.config.appId = config.appId;
    }
    init() {
        this.ua = this.UA = window.navigator.userAgent;
        this.checkSysEnv()
            .checkAppEnv()
            .checkTBS()
            .reportPV();
    }
    checkSysEnv() {
        if (/android/ig.test(this.ua)) {
            this.isAndroid = true;
        }
        else if (/iphone|ipod|iPad/ig.test(this.ua)) {
            this.isIos = true;
        }
        return this;
    }
    checkAppEnv() {
        if (/mqq/ig.test(this.ua)) {
            this.isQb = true;
        }
        else if (/mobile.*qq/gi.test(this.ua)) {
            this.isQQ = true;
            if (/mobile.*mqqbrowser/gi.test(this.ua)) {
                this.isQQ = false;
            }
        }
        else if (/qzone/gi.test(this.ua)) {
            this.isQZ = true;
        }
        else if (/micromessenger/gi.test(this.ua)) {
            this.isWX = true;
        }
        return this;
    }
    checkTBS() {
        if (/ TBS\//i.test(this.UA)) {
            this.isTBS = true;
        }
        return this;
    }
    reportPV() {
        const sender = new Image();
        sender.src = `${config.reportUrl}?appId=${this.config.appId}&scene=init&msg=init`;
        return this;
    }
    reportError(errorMsg) {
        try {
            const sender = new Image();
            sender.src = `${config.reportUrl}?appId=${this.config.appId}&scene=error&msg=${errorMsg}`;
        }
        catch (error) {
        }
    }
    reporter(params) {
        try {
            const sender = new Image();
            sender.src = `${config.reportUrl}?appId=${this.config.appId}&scene=${params.scene}&msg=${params.msg}`;
        }
        catch (error) {
            this.reportError(error.meessage);
        }
    }
}
//# sourceMappingURL=base.js.map